import Swiper from 'swiper/bundle'

/**
 * ProductReviewsSlider component.
 * @author Dayne Coulson-Hoffacker
 */
export default class ProductReviewsSlider {
  /**
   * Constructs a new Slider component.
   * @param {Object} options - Options.
   * @param {HTMLElement} options.element - Container.
   */
  constructor(options) {
    this.element = options.element
    this.swiperContainer = this.element.querySelector('.swiper-container')
    this.swiperPagination = this.element.querySelector('.swiper-pagination')
    this.swiperButtonPrev = this.element.querySelector('[data-component="slider-navigation-btn-prev"]')
    this.swiperButtonNext = this.element.querySelector('[data-component="slider-navigation-btn-next"]')
    this.swiperSlides = this.element.queryAll('.swiper-slide')

    if (this.swiperSlides.length <= 3) {
      this.element.classList.add('hide-pagination-navigation')
    }

    var slider = new Swiper(this.swiperContainer, {
      slidesPerView: 1,
      watchOverflow: true,
      autoHeight: true,
      pagination: {
        el: this.swiperPagination,
        type: 'bullets',
        clickable: true
      },
      breakpoints: {
        768: {
          slidesPerView: 2,
          spaceBetween: 96
        },
        1024: {
          slidesPerView: 3,
          spaceBetween: 96
        }
      }
    })

    if (this.swiperButtonPrev) {
      this.swiperButtonPrev.addEventListener('click', () => {
        slider.slidePrev()
      })
    }

    if (this.swiperButtonNext) {
      this.swiperButtonNext.addEventListener('click', () => {
        slider.slideNext()
      })
    }
  }
}



// WEBPACK FOOTER //
// ./components/woocommerce/single-product/single-product-reviews/index.js